import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Block, Tag, Text } from '@/presentation/components';
import presencialCancelado from '../../../../../assets/icons/map-pin.svg';
import virtualClass from '../../../../../assets/icons/IconRemote.svg';
import TextHelper from '@/core/helpers/TextHelper';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

export const ImgContainer = styled.img`
  width: fit-content;
  background-color: #e2dffd;
  border: 2px;
  border-radius: 50%;
  padding: 6px;
  margin-right: 7px;
  align-self: baseline;
  @media (max-width: 500px) {
    margin-bottom: 16px;
  }
`;

export const MainContainer = styled.div`
  padding-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: 100%;
  gap: 12px;

  & {
    .headerContainer {
    display: flex;
    width: 1125px;
    flex-direction: column;
    max-Height=inherit;
    min-Height=inherit;
    padding: 0px 8px;
  }
  .virtualContainer{
    display: flex;
    z-Index: 1;
    position: relative;
    top: 41px;
    left: 8px;
  }
  .gridContainer {
    display: flex;
    flex-Direction: column;
    marginTop: 12px;
    z-Index: 0;
    gap: 16px;
    // height: 80vh;
    // min-height: 600px;
    // top: -96px;
    position: absolute;
    padding-bottom: 32px;
  }

  .legendContainer {
    margin: 400px 0px 100px 0px;
    background-color: var(--background-background-UTP);
    border-radius: 8px;
    padding: 8px;
  }

  .hasRelatedCourses {
    display: flex;
    font-family: Lato;
    font-size: 12px;
    background-color: var(--background-background-UTP);
    padding: 8px;
    border-radius: 8px;
    gap: 9px;
    min-width: 1125px;
  }

  ul {
    margin-Left: 16px;
    list-style-type: inherit;
    width: 100%;
  }
  li {
    font-Size: 14px;
    break-Inside: avoid;
    color: rgba(22, 29, 31, 1);
  }
}

  @media (min-width: 1150px) {
    padding-left: 0px;
    padding-right: 0px;
    align-items: center;

    // .virtualContainer{
    //   left: 0px;
    // }
  }
`;

interface IContenedor1Props {
  children?: ReactNode;
  maxCoursesByDay: number;
}

export const Contenedor1 = ({
  children,
  maxCoursesByDay
}: IContenedor1Props) => (
  <div
    style={{
      paddingTop: 12,
      paddingLeft: 8,
      paddingBottom: 12,
      paddingRight: 8,
      // marginRight: 16,
      // marginLeft: 16,
      backgroundColor: '#ECF4F9',
      borderRadius: 8,
      width: 147,
      minWidth: 147,
      height: 'max-content',
      minHeight: `${220 + 148 * maxCoursesByDay}px`
    }}
  >
    {children}
  </div>
);

export const Cmp2 = ({ currentDate }: any) => {
  const { classroom, type, name, start, end } = currentDate;
  const classroomName =
    classroom.length === 7 ? classroom.substring(2, 7) : classroom;
  return (
    <>
      <div
        style={{
          display: 'flex'
        }}
      >
        <Tag
          backgroundColor={type === 'Presencial' ? '#bf500b' : '#0F6778'}
          color={'#FFF8F7'}
          padding="0 10px"
          width="70px"
          radius={20}
          lineHeight={16}
          size={12}
          height={24}
          center
        >
          {type}
        </Tag>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}
      >
        <Text color={'#161D1F'} fontSize={'14px'} fontWeight={700}>
          {TextHelper.capitalize(name)}
        </Text>
        <Text color={'#161D1F'} fontSize={'14px'} fontWeight={400} level={1}>
          {`${start} - ${end}`}
        </Text>
      </div>
      <Block customized display="flex" flexDirection="row" alignItems="center">
        <img
          alt="Icon"
          src={type === 'Virtual en vivo' ? virtualClass : presencialCancelado}
          style={{
            width: '20px',
            height: '20px',
            fill: '#000000'
          }}
        />
        <Text
          color={'#161D1F'}
          fontSize={'12px'}
          fontWeight={400}
          style={{ marginLeft: '3px' }}
        >
          {type === 'Virtual en vivo' ? 'Zoom' : classroomName}
        </Text>
      </Block>
    </>
  );
};
interface Contenedor2Props {
  currentDate: any;
  virtual24: any;
  handlerRedirectNewPage: any;
}

const ButtonContenedor2 = styled.button.attrs((props: any) => ({
  margin: props.margin
}))`
  width: 100%;
  background-color: #fff;
  margin: ${(props) => props.margin};
  borderradius: 4px;
  shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.4);
  display: flex;
  justifycontent: flex-start;
  alignitems: center;
  :hover {
    background-color: #d5e5f0;
    transition: background 400ms ease-in-out;
  }
  :focus {
    background-color: #a8cbe2;
  }
`;

export const Contenedor2: React.FC<Contenedor2Props> = (props) => {
  const { currentDate, virtual24, handlerRedirectNewPage } = props;
  return (
    <ButtonContenedor2
      className="interaction"
      data-testid="button-ds-customized"
      margin={`${virtual24.length > 0 ? '0px' : '32px'} 0px 12px 0px`}
      onClick={() => {
        GoogleAnalytics.writeLog(
          'click-card-horariomatriculado',
          'schedule-modal'
        );
        handlerRedirectNewPage('https://class.utp.edu.pe/');
      }}
    >
      <Block key={currentDate.courseId} customized width="180px" heigth="300px">
        <div
          style={{
            boxShadow: '0px 6px 12px -6px var(--neutral-01)',
            borderRadius: 4,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            padding: 8,
            minHeight: 140
          }}
        >
          <Cmp2 currentDate={currentDate} />
        </div>
      </Block>
    </ButtonContenedor2>
  );
};

export const TitleText = ({ text, style }: any) => (
  <Text
    color={'#161D1F'}
    fontSize={'14px'}
    fontWeight={400}
    level={1}
    style={{
      display: 'flex',
      marginBottom: '128px',
      justifyContent: 'center',
      ...style
    }}
  >
    {text}
  </Text>
);
